// src/v3/ui/_common/components/layout/header.tsx

import { ThemeToggle } from "../ui/theme-toggle";

export function Header() {
  return (
    <header className="flex h-14 items-center justify-between border-b px-6">
      <h1 className="text-lg font-semibold">Signals App</h1>
      <ThemeToggle />
    </header>
  );
}
